import Vue from 'vue'

Vue.filter('formatDate',function(dateTime) { 
    if(!(isNaN(dateTime)&&!isNaN(Date.parse(dateTime)))){
        return dateTime;
    }
    let now = new Date(parseInt(dateTime));
    let year = now.getFullYear(); 
    let month = (now.getMonth()+1) < 10 ? '0' + (now.getMonth()+1) : now.getMonth()+1; 
    let date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate(); 
    let hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours(); 
    let minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes(); 
    let second = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds(); 
    return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second; 
} );


// WEBPACK FOOTER //
// ./src/filters/formatDate.js